exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divider-f10Cq{border-top:1px solid rgba(255,255,255,.3);margin:20px 0}.divider-f10Cq.noMargin-1nDGB{margin:0}.theme-dark .divider-f10Cq{border-color:rgba(255,255,255,.3)}.theme-light .divider-f10Cq{border-color:rgba(180,191,213,.5)}", ""]);

// exports
exports.locals = {
	"divider": "divider-f10Cq",
	"noMargin": "noMargin-1nDGB"
};